<nav>

	<div class="nav-group" ngbDropdown container="body" placement="right-top">
		<div data-testid="SUBSYS2_SIDEBAR_MENU_TOGGLE" class="nav-link" ngbDropdownToggle>
			<span class="material-icons">account_circle</span>
		</div>

		<div class="dropdown-menu" ngbDropdownMenu>
			<div data-testid="SUBSYS2_SIDEBAR_MENU_EDITPROFILE" class="dropdown-item text-truncate" (click)="editProfile()"
				(keypress)="editProfile()" [title]="labels().SIDEBAR_COMPONENT_EDIT_PROFILE">
				{{ labels().SIDEBAR_COMPONENT_EDIT_PROFILE }}
			</div>
			<div data-testid="SUBSYS2_SIDEBAR_MENU_CHANGEPWD" class="dropdown-item text-truncate" (click)="changePassword()"
				(keypress)="changePassword()" [title]="labels().SIDEBAR_COMPONENT_CHANGE_PASSWORD">
				{{ labels().SIDEBAR_COMPONENT_CHANGE_PASSWORD }}
			</div>
			<div data-testid="SUBSYS2_SIDEBAR_MENU_LEGALTERMS" class="dropdown-item text-truncate" (click)="openLegalTerms()"
				(keypress)="openLegalTerms()" [title]="labels().SIDEBAR_COMPONENT_EULA_POLICY">
				{{ labels().SIDEBAR_COMPONENT_EULA_POLICY }}
			</div>
			<div data-testid="SUBSYS2_SIDEBAR_MENU_ABOUT" class="dropdown-item text-truncate" (click)="openAboutPage()"
				(keypress)="openAboutPage()" [title]="labels().SIDEBAR_COMPONENT_ABOUT">
				{{ labels().SIDEBAR_COMPONENT_ABOUT }}
			</div>
			<div data-testid="SUBSYS2_SIDEBAR_MENU_COOKIE" class="dropdown-item text-truncate" (click)="openCookieModal()"
				(keypress)="openCookieModal()" [title]="labels().SIDEBAR_COMPONENT_COOKIE">
				{{ labels().SIDEBAR_COMPONENT_COOKIE }}
			</div>
			@if (envName != 'production') {
			<div data-testid="SUBSYS2_SIDEBAR_MENU_VERSION" class="simple-text">{{ buildVersion }}</div>
			}
			<div data-testid="SUBSYS2_SIDEBAR_MENU_LOGOUT" class="dropdown-item text-truncate" (click)="logout()"
				(keypress)="logout()" [title]="labels().SIDEBAR_COMPONENT_LOGOUT">
				{{ labels().SIDEBAR_COMPONENT_LOGOUT }}
			</div>
		</div>
	</div>

	<a data-testid="SUBSYS2_SIDEBAR_DASHBOARD_BTN" class="nav-link" style="bottom: 50%"
		[routerLink]="`/${PAGE.DASHBOARD}`" routerLinkActive="active">
		<i class="material-icons-outlined">dashboard</i>
	</a>

</nav>